import React from 'react';
import { datePadStart } from '../../../helpers';


interface MaintananceCountDownDigitsProps {
  digits: number;
  name: string;
}

export const MaintenanceCountdownDigits: React.FC<MaintananceCountDownDigitsProps> = ({
  digits,
  name,
}) => {
  const renderDigit = (value: number) => {
    const padded = datePadStart(value);
    return <span className="base">{padded}</span>;
  };
  return <>
    <div className="digit-wr">
      <div className="digit hour">{renderDigit(digits)}</div>
      <div className="digit-name">{name}</div>
    </div>
  </>;
};
